/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protein_Meals_Four_PlusInputs */

const en_us2_protein_meals_four_plus = /** @type {(inputs: Protein_Meals_Four_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 or more`)
};

const pt_br2_protein_meals_four_plus = /** @type {(inputs: Protein_Meals_Four_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quatro ou mais`)
};

const es_419_protein_meals_four_plus = /** @type {(inputs: Protein_Meals_Four_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 o más`)
};

const pt_pt2_protein_meals_four_plus = /** @type {(inputs: Protein_Meals_Four_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quatro ou mais`)
};

const fr_fr2_protein_meals_four_plus = /** @type {(inputs: Protein_Meals_Four_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 ou plus`)
};

const de_de2_protein_meals_four_plus = /** @type {(inputs: Protein_Meals_Four_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vier oder mehr`)
};

const it_it2_protein_meals_four_plus = /** @type {(inputs: Protein_Meals_Four_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quattro o più`)
};

/**
* | output |
* | --- |
* | "4 or more" |
*
* @param {Protein_Meals_Four_PlusInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protein_meals_four_plus = /** @type {((inputs?: Protein_Meals_Four_PlusInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protein_Meals_Four_PlusInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protein_meals_four_plus(inputs)
	if (locale === "es-419") return es_419_protein_meals_four_plus(inputs)
	if (locale === "pt-PT") return pt_pt2_protein_meals_four_plus(inputs)
	if (locale === "fr-FR") return fr_fr2_protein_meals_four_plus(inputs)
	if (locale === "de-DE") return de_de2_protein_meals_four_plus(inputs)
	if (locale === "it-IT") return it_it2_protein_meals_four_plus(inputs)
	return en_us2_protein_meals_four_plus(inputs)
});
export { protein_meals_four_plus as "protein_meals.four_plus" }